import React, { useRef, useState } from 'react'
import { Carousel, Modal, Row } from 'react-bootstrap'
import styled from 'styled-components'
import Agenda1 from '../../images/event/agenda-01.jpg'
import Agenda2 from '../../images/event/agenda-02.jpg'
import agendaIcon from '../../images/event/agenda.png'
import speakerIcon from '../../images/event/speaker.png'
import Speaker1 from '../../images/event/speaker1.jpg'
import Speaker2 from '../../images/event/speaker2.jpg'
import Speaker3 from '../../images/event/speaker3.jpg'
import Speaker4 from '../../images/event/speaker4.jpg'
import Speaker5 from '../../images/event/speaker5.jpg'
import { COLORS, SIZES } from '../../styles/theme'

const StyledModal = styled(Modal)`
  text-align: center;
  color: #002060;

  .modal-dialog {
    min-width: 75%;
  }
  .modal-content {
    background-color: rgba(255, 255, 255, 1);
    box-shadow: 0px 4px 12px ${COLORS.lightGray1};
    border: none;
    border-radius: 0;
    padding: 24px 36px;
    margin-bottom: 24px;

    .modal-header {
      color: #ffad2c;
      border: none;
      text-align: left;
      .modal-title {
        font-size: 36px;
        font-weight: bold;
        font-style: italic;
      }
      button {
        font-size: 36px;
        opacity: 1;
        color: rgba(0, 0, 0, 0.55);
      }
    }
    .header-section {
      .navigation {
        height: 100%;
        width: 80%;
        margin: 0 auto;
        display: flex;
        justify-content: space-around;
        align-items: flex-end;
        button {
          background: linear-gradient(#ff9821, #f83636);
          color: white;
          border: 2px solid #ff9821;
          border-radius: 12px;
          padding: 6px 16px;
          display: flex;
          justify-content: space-around;
          align-items: center;
          h5 {
            margin: 0 4px;
          }
          &:hover {
            background: #ff9821;
          }
        }
      }
    }
    .divider {
      background: #002060;
      height: 4.5px;
      margin: 32px 0;
    }
  }
  .back-top {
    border: none;
    border-radius: 12px;
    background: linear-gradient(#ff9821, #f83636);
    position: absolute;
    bottom: 0;
    right: 0;
    svg {
      width: 50;
      height: 50;
    }
  }
  .modal-body {
    padding-bottom: 36px;
  }
  .agenda {
    button {
      margin: 0 16px;
      background: linear-gradient(#ff9821, #f83636);
      border: 2px solid #ff9821;
      font-weight: 500;
      border-radius: 12px;
      padding: 4px 12px;
      color: white;
      font-size: 16px;
    }
    .active {
      font-style: italic;
      color: #002060;
      /* text-decoration: underline; */
    }
  }

  #agenda-container {
    width: 80%;
    margin: 10px auto;
    header {
      font-size: 24px;
      button {
        padding: 6px 16px;
      }
    }
    section {
      text-align: left;
      font-size: 18px;
    }
  }

  .speaker-container {
    width: 80%;
    margin: 10px auto;
  }
`

const StyledCarousel = styled(Carousel)`
  .carousel-control-next,
  .carousel-control-prev {
    opacity: 1;
  }

  .carousel-control-prev {
    left: -5%;
    ${SIZES.mobile} {
      left: -5%;
    }
  }
  .carousel-control-next {
    right: -5%;
    ${SIZES.mobile} {
      right: -5%;
    }
  }

  .carousel-control-next-icon,
  .carousel-control-prev-icon {
    width: 30px;
    height: 30px;
  }
`

const speakerList = [
  {
    id: 1,
    image: Speaker1,
  },
  {
    id: 2,
    image: Speaker2,
  },
  {
    id: 3,
    image: Speaker3,
  },
  {
    id: 4,
    image: Speaker4,
  },
  {
    id: 5,
    image: Speaker5,
  },
]

export default function ProgrammeModal({ showModal, hideSchedule }) {
  const facultySec = useRef()
  const agendaSec = useRef()
  const startModal = useRef()
  const [day, setDay] = useState(1)

  const scrollTop = (ref) => {
    ref.current.scrollIntoView({ behavior: 'smooth' })
  }

  return (
    <StyledModal show={showModal} onHide={hideSchedule} size="xl" aria-labelledby="menu-modal" centered>
      <Modal.Header closeButton>
        <span ref={startModal} />
      </Modal.Header>
      <Modal.Body>
        <Row className="header-section" noGutters>
          <div className="navigation">
            <button onClick={() => scrollTop(agendaSec)}>
              <img src={agendaIcon} width="24" alt="nav" />
              <h5>Programme</h5>
            </button>
            <button onClick={() => scrollTop(facultySec)}>
              <img src={speakerIcon} width="24" alt="nav" />
              <h5>Speakers</h5>
            </button>
          </div>
        </Row>
        <span ref={agendaSec} />
        <div className="divider" />

        <div className="agenda">
          <button className={`${day === 1 && 'active'}`} onClick={() => setDay(1)}>
            Day 1 - 25th of Sept
          </button>
          <button className={`${day === 2 && 'active'}`} onClick={() => setDay(2)}>
            Day 2 - 26th of Sept
          </button>
        </div>

        <div id="agenda-container">
          {day === 1 ? <img className="d-block w-100" src={Agenda1} alt="agenda-01" /> : <img className="d-block w-100" src={Agenda2} alt="agenda-02" />}
        </div>

        <div className="divider" />

        <div className="speaker-container">
          <div ref={facultySec} />
          <StyledCarousel>
            {speakerList.map((speaker, index) => (
              <Carousel.Item key={`speaker-${index}`} interval={4000}>
                <img className="d-block w-100" src={speaker.image} alt={`speaker-${index}`} />
              </Carousel.Item>
            ))}
          </StyledCarousel>
        </div>

        <div className="divider" />
        <button onClick={() => scrollTop(startModal)} className="back-top">
          <svg width="45" height="45" viewBox="0 0 45 45">
            <g transform="translate(-1767 -3747)">
              <g transform="translate(120 -2428)">
                <path
                  d="M22.175,9.358a1.43,1.43,0,0,0-1.43-1.43H5.063l5.813-5.42A1.43,1.43,0,1,0,8.923.421L.455,8.311a1.43,1.43,0,0,0,0,2.091L8.923,18.3A1.43,1.43,0,1,0,10.875,16.2L5.063,10.788H20.746A1.43,1.43,0,0,0,22.175,9.358Z"
                  transform="translate(1678.681 6187) rotate(90)"
                  fill="#fff"
                />
              </g>
            </g>
          </svg>
        </button>
      </Modal.Body>
    </StyledModal>
  )
}
